// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  runKey: __t.string(),
  legKey: __t.string(),
  t: __t.f32(),
  fps: __t.f32(),
  frameMsP50: __t.f32(),
  frameMsP95: __t.f32(),
  frameMsMax: __t.f32(),
  drawCalls: __t.u32(),
  triangles: __t.u64(),
  pipelines: __t.u32(),
  heapMb: __t.f32(),
  gpuMs: __t.f32(),
  loaf: __t.u32(),
  x: __t.f64(),
  z: __t.f64(),
  censusJson: __t.string(),
};
